import { WebLocale } from './web-locale';
export enum Currency {
	ad = 'EUR',
	ae = 'AED',
	ag = 'XCD',
	al = 'ALL',
	ao = 'AOA',
	ar = 'ARS',
	at = 'EUR',
	au = 'AUD',
	az = 'AZN',
	ba = 'BAM',
	bb = 'BBD',
	be = 'EUR',
	bf = 'XOF',
	bg = 'BGN',
	bh = 'BHD',
	bm = 'BMD',
	bo = 'BOB',
	br = 'BRL',
	bs = 'BSD',
	by = 'BYN',
	bz = 'BZD',
	ca = 'CAD',
	cd = 'CDF',
	ch = 'CHF',
	ci = 'XOF',
	cl = 'CLP',
	cm = 'XAF',
	co = 'COP',
	cr = 'CRC',
	cu = 'CUP',
	cv = 'CVE',
	cy = 'EUR',
	cz = 'CZK',
	de = 'EUR',
	dk = 'DKK',
	do = 'DOP',
	dz = 'DZD',
	ec = 'USD',
	ee = 'EUR',
	eg = 'EGP',
	es = 'EUR',
	fi = 'EUR',
	fj = 'FJD',
	fr = 'EUR',
	gf = 'EUR',
	gg = 'GBP',
	gh = 'GHS',
	gi = 'GIP',
	gq = 'XAF',
	gr = 'EUR',
	gt = 'GTQ',
	gy = 'GYD',
	hk = 'HKD',
	hn = 'HNL',
	hr = 'HRK',
	hu = 'HUF',
	id = 'IDR',
	ie = 'EUR',
	il = 'ILS',
	in = 'INR',
	iq = 'IQD',
	is = 'ISK',
	it = 'EUR',
	jm = 'JMD',
	jo = 'JOD',
	jp = 'JPY',
	ke = 'KES',
	kr = 'KRW',
	kw = 'KWD',
	lb = 'LBP',
	lc = 'XCD',
	li = 'CHF',
	lt = 'EUR',
	lu = 'EUR',
	lv = 'EUR',
	ly = 'LYD',
	ma = 'MAD',
	mc = 'EUR',
	md = 'MDL',
	me = 'EUR',
	mg = 'MGA',
	mk = 'MKD',
	ml = 'XOF',
	mt = 'EUR',
	mu = 'MUR',
	mw = 'MWK',
	mx = 'MXN',
	my = 'MYR',
	mz = 'MZN',
	ne = 'XOF',
	ng = 'NGN',
	ni = 'NIO',
	nl = 'EUR',
	no = 'NOK',
	nz = 'NZD',
	om = 'OMR',
	pa = 'PAB',
	pe = 'PEN',
	pf = 'XPF',
	pg = 'PGK',
	ph = 'PHP',
	pk = 'PKR',
	pl = 'EUR',
	ps = 'JOD',
	pt = 'EUR',
	py = 'PYG',
	qa = 'QAR',
	ro = 'RON',
	rs = 'RSD',
	ru = 'RUB',
	sa = 'SAR',
	sc = 'SCR',
	se = 'SEK',
	sg = 'SGD',
	si = 'EUR',
	sk = 'EUR',
	sm = 'EUR',
	sn = 'XOF',
	sv = 'SVC',
	tc = 'USD',
	td = 'XAF',
	th = 'THB',
	tn = 'TND',
	tr = 'TRY',
	tt = 'TTD',
	tw = 'TWD',
	tz = 'TZS',
	ua = 'UAH',
	ug = 'UGX',
	uk = 'GBP',
	us = 'USD',
	uy = 'UYU',
	va = 'EUR',
	ve = 'VES',
	xk = 'EUR',
	ye = 'YER',
	za = 'ZAR',
	zm = 'ZMW',
	zw = 'ZWL',
}

// Conversions of 1 euro to countries currency
export const Conversions: { [key in WebLocale]?: number } = {
	[WebLocale.se]: 10.86,
	[WebLocale.ro]: 4.94,
	[WebLocale.hu]: 399.02,
	[WebLocale.dk]: 7.44,
	[WebLocale.cz]: 24.64,
	[WebLocale.hr]: 7.52,
	[WebLocale.bg]: 1.96,
};
